import React from 'react';
import { Award } from 'lucide-react';

export function Achievements() {
  return (
    <div className="bg-white dark:bg-accessible-gray-800 high-contrast:bg-black p-8 rounded-lg shadow-lg">
      <div className="flex items-center gap-4 mb-6">
        <div className="w-12 h-12 rounded-full bg-accessible-red-600/10 flex items-center justify-center">
          <Award className="w-6 h-6 text-accessible-red-600" aria-hidden="true" />
        </div>
        <h2 className="card-title">
          Nasze osiągnięcia
        </h2>
      </div>
      
      <div className="space-y-6">
        <div className="grid grid-cols-2 gap-4">
          <div className="text-center">
            <div className="stat-number text-accessible-red-600 mb-2">1200+</div>
            <p className="stat-label">
              Uratowanych zwierząt
            </p>
          </div>
          <div className="text-center">
            <div className="stat-number text-accessible-red-600 mb-2">850+</div>
            <p className="stat-label">
              Udanych adopcji
            </p>
          </div>
        </div>
        
        <div className="space-y-4">
          <h3 className="heading-5">
            Wyróżnienia
          </h3>
          <ul className="space-y-2">
            <li className="list-item">
              <Award className="w-4 h-4 text-accessible-red-600" aria-hidden="true" />
              <span>Nagroda "Przyjaciel Zwierząt" 2023</span>
            </li>
            <li className="list-item">
              <Award className="w-4 h-4 text-accessible-red-600" aria-hidden="true" />
              <span>Wyróżnienie za działalność charytatywną 2022</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}